module.exports = __webpack_public_path__ + "static/media/group_3.a862060f.png";